import { render, staticRenderFns } from "./RecentlySelectedCand.vue?vue&type=template&id=60e0b1ee&scoped=true&"
import script from "./RecentlySelectedCand.vue?vue&type=script&lang=js&"
export * from "./RecentlySelectedCand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0b1ee",
  null
  
)

export default component.exports